// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table--border[data-v-eb67783a] {\n  border-left: 2px solid #ebeef5;\n  border-top: 2px solid #ebeef5;\n  border-right: 1px solid #ebeef5;\n  border-bottom: 1px solid #ebeef5;\n}\n.cfdContent td[data-v-eb67783a] {\n  text-align: center;\n}\n.cfdDiv tr[data-v-eb67783a] {\n  line-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
